import ChannelTalkBtn from "@/components/atoms/ChannelTalkBtn";
import LandingPageLnbMolecule from "@/components/molecules/LandingPageMolecules/LandingPageLnbMolecule";
import { Footer } from "@/components/organisms/Footer";
import {
  BusinessInfoItems,
  CopyRightText,
  FooterInfoFirstLineItems,
  FooterInfoSecondLineItems,
  FooterNavItems,
  FooterSNSItems,
  InfoDropDownIconImg,
  InfoDropDownText,
} from "@/components/organisms/Footer/footer.models";
import Hero from "./components/Hero";
import Courses from "./components/Courses";
import Specialties from "./components/Specialties";
import Campaign from "./components/Campaign";
import BottomBanner from "./components/BottomBanner";
import { useEffect } from "react";
import { sendLog } from "@/businessLogics/_common/logging";
import AlimModal from "@/components/organisms/AlimModalOrganisms/AlimModal";
import { alimModalCourseAtom } from "@/states/notification";
import { useAtomValue } from "jotai";

export default function Template({ userInfo }) {
  useEffect(() => {
    sendLog("sw_mainPage_view", { page_name: "메인" });
  }, []);
  const alimModalCourse = useAtomValue(alimModalCourseAtom);
  return (
    <>
      <AlimModal userInfo={userInfo} course={alimModalCourse} />
      <LandingPageLnbMolecule userInfo={userInfo} />
      <Hero />
      <Courses userInfo={userInfo} />
      <Specialties />
      {/* 퇴근할 결심 종료에 따른 주석 처리 */}
      {/* <Campaign /> */}
      <BottomBanner />
      <Footer
        footerNavItems={FooterNavItems}
        footerSNSItems={FooterSNSItems}
        footerInfoFirstLineItems={FooterInfoFirstLineItems}
        footerInfoSecondLineItems={FooterInfoSecondLineItems}
        businessInfoItems={BusinessInfoItems}
        infoDropDownText={InfoDropDownText}
        infoDropDownIconImg={InfoDropDownIconImg}
        copyRightText={CopyRightText}
      />
      <ChannelTalkBtn />
    </>
  );
}
